import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { HoopsViewerContext } from "./ViewerContext";

function useViewerCallbacks({ viewerCallbacks, triggerRerender }: any) {
  const [viewerRerenderedToggle, setViewerRerenderedToggle] = useState(0);
  const previousViewerCallback = useRef(null);
  const { fileVersionId, isModelStructureReady, viewerImpl }: any = useContext(HoopsViewerContext);
  const prevFileVersionId = useRef(fileVersionId);
  const { modelProperties }: any = useSelector((state) => state);

  const unsetCallbacks = () => {
    if (previousViewerCallback.current != null && viewerImpl) {
      viewerImpl.unsetCallbacks(previousViewerCallback.current);
    }
  };

  const viewerCallbacksMemoized = useMemo(() => {
    if (prevFileVersionId.current != fileVersionId) {
      setViewerRerenderedToggle(0);
      prevFileVersionId.current = fileVersionId;
    }
    if (previousViewerCallback.current != null) {
      unsetCallbacks();
    }

    previousViewerCallback.current = viewerCallbacks;
    return viewerCallbacks;
  }, [fileVersionId, modelProperties.isLoaded, triggerRerender, isModelStructureReady, viewerImpl]);

  useEffect(() => {
    if (previousViewerCallback.current != null && viewerImpl) {
      viewerImpl.setCallbacks(previousViewerCallback.current);
      setViewerRerenderedToggle(viewerRerenderedToggle + 1);
    }
  }, [viewerCallbacksMemoized]);

  useEffect(() => () => unsetCallbacks(), []);

  return viewerRerenderedToggle;
}

export default useViewerCallbacks;
